import React from 'react';
import { Checkbox, Form, ReformSubmitHandler, Submit } from '@kodkafa/reform';
import { useTranslation } from 'react-i18next';
import {
  ClanRoleSettings,
  useClanControllerFindOneQuery,
  useClanControllerUpdateMutation,
} from '@/store/services/MidleNestApi.service';
import { useLocation } from 'react-router-dom';

function RoleSettingItem({ role, changeRole, removeUser, invite }: ClanRoleSettings) {
  return (
    <tr>
      <th className='text-sm font-medium'>{role}</th>
      <td className='py-2'>
        <Checkbox
          className='justify-center'
          name={role + '_removeUser'}
          defaultChecked={removeUser}
          disabled={role === 'newbie'}
        />
      </td>
      <td className='py-2'>
        <Checkbox
          className='justify-center'
          name={role + '_changeRole'}
          defaultChecked={changeRole}
          disabled={role === 'newbie'}
        />
      </td>
      <td className='py-2'>
        <Checkbox
          className='justify-center'
          name={role + '_invite'}
          defaultChecked={invite}
          disabled={role === 'newbie'}
        />
      </td>
    </tr>
  );
}

export default function RoleSettings() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const guildId = React.useMemo(() => pathname.split('/')[2], [pathname]);

  const { data } = useClanControllerFindOneQuery(guildId);
  const [updateRoleSetting] = useClanControllerUpdateMutation();

  const onSubmitHandler = React.useCallback<ReformSubmitHandler<{ [setting: string]: boolean }>>(
    async (settings) => {
      const roleSettings = [];
      const dtos: { [role: string]: any } = {};

      for (const item of Object.keys(settings)) {
        const [role, key] = item.split('_');
        const value = settings[item];

        if (!dtos[role]) dtos[role] = { role };

        dtos[role][key] = Boolean(value);
      }

      for (const role of Object.keys(dtos)) {
        roleSettings.push(dtos[role]);
      }

      await updateRoleSetting({
        id: data?.id || '',
        updateClanDto: { roleSettings: roleSettings },
      });
    },
    [data, updateRoleSetting],
  );

  return (
    <div className='flex flex-col gap-y-8'>
      <h3 className='text-xl leading-7 font-medium'>{t('Role Settings')}</h3>
      <div className='overflow-y-auto max-h-none sm:max-h-[530px] pr-2 pb-2'>
        <Form onSubmit={onSubmitHandler}>
          <table className='table-fixed w-full'>
            <thead>
              <tr>
                <th className='text-sm leading-5 font-medium' />
                <th className='text-sm leading-5 font-medium text-center'>{t('Remove User')}</th>
                <th className='text-sm leading-5 font-medium text-center'>{t('Change Role')}</th>
                <th className='text-sm leading-5 font-medium text-center'>{t('Invite')}</th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data?.roleSettings &&
                data?.roleSettings.map((item) => (
                  <RoleSettingItem key={'role_' + item.role} {...item} />
                ))}
            </tbody>
          </table>

          <div className='flex justify-end mt-4'>
            <Submit className='py-1'>{t('Save')}</Submit>
          </div>
        </Form>
      </div>
    </div>
  );
}
